module.exports = __webpack_public_path__ + "img/20.49a13b32.png";